import sxsStore from '../store/Store';
import { isClientAttachmentIdEqual } from 'owa-client-ids';
export default function isSxSDisplayed() {
    return sxsStore.shouldShow;
}
export function isSxSDisplayedAndShouldHideConversationReadingPane() {
    return sxsStore.shouldShow && sxsStore.shouldHideReadingPaneOutsideSxS;
}
export function isSxSDisplayedForAttachment(id) {
    return (isSxSDisplayed() && isClientAttachmentIdEqual(id, sxsStore.extendedViewState.attachmentId));
}
/**
 * If composeViewState is truthy, it will check if SxS is displaying that exact same compose view state
 * If composeViewState is falsy, it will check if any compose is displaying in SxS
 */
export function isSxSDisplayedWithCompose(composeViewState) {
    return (isSxSDisplayed() &&
        ((composeViewState && composeViewState === sxsStore.composeState) ||
            (!composeViewState && sxsStore.composeState)));
}
//# sourceMappingURL=isSxSDisplayed.js.map